<template>
  <form name="form-address" id="form-address" v-async="loadingAddress">
    <!-- <div class="container"> -->

    <div class="row"  v-async="loadingAddress">
      <div class="col-xs-12">
        <b class="title-identification margin-b10">Endereço <template v-if="type=='BILLING'"> da fatura do cartão</template></b>
        <!-- <div class="form-content"> -->
        <div class="form-content">
          <div class="alert alert-danger alert-dismissable margin-b10" v-show="errorCep">
            <a class="close" aria-label="close" @click="errorCep=undefined">&times;</a> {{ errorCep }}
          </div>
          <div class="form-group margin-b30 input-box-control input-box-cep" :class="{'has-error': errors.has('cep')}">
            <div class="label-box"><label>CEP:*</label></div>
            <div class="input-box">
              <input type="text" name="cep" v-model="address.zipCode" v-validate="'required|min:8|cep'" maxlength="8"
              class="form-control small" @input="queryAddressTyping" v-only-numbers placeholder="00000-000">
              <div class="help-block">
                {{ errors.first('cep') }}
              </div>
            </div>
            <a class="label-link" v-on:click="queryAddress">Buscar CEP</a></div>
            <div>
              <div class="form-group margin-b30 input-box-control inline" :class="{'has-error': errors.has('logradouro')}">
                <div class="label-box"><label>Logradouro:*</label></div>
                <div class="input-box">
                  <input type="text" name="logradouro" v-model="address.address" v-validate="'required|max:50'" class="form-control small" maxlength="50">
                  <div class="help-block">
                    {{ errors.first('logradouro') }}
                  </div>
                </div>
              </div>
              <div class="form-group margin-b30 input-box-control inline input-box-number" :class="{'has-error': errors.has('numero')}">
                <div class="label-box number-box"><label>Número:*</label></div>
                <div class="input-box">
                  <input type="text" name="numero" v-model="address.number" v-validate="'required|max:5'" class="form-control small" maxlength="5">
                  <div class="help-block">
                    {{ errors.first('numero') }}
                  </div>
                </div>
              </div>
              <div class="form-group margin-b30 input-box-control inline input-box-adjunct">
                <div class="label-box"><label>Complemento:</label></div>
                <div class="input-box">
                  <input type="text" name="complemento" v-model="address.complement" class="form-control small" maxlength="20">
                  <div class="help-block"></div>
                </div>
              </div>
            </div>
            <div>
              <div class="form-group margin-b30 input-box-control inline input-box-medium" :class="{'has-error': errors.has('bairro')}">
                <div class="label-box"><label>Bairro:*</label></div>
                <div class="input-box">
                  <input type="text" name="bairro" v-model="address.neighborhood" v-validate="'required|max:30'" class="form-control small" maxlength="30">
                  <div class="help-block">
                    {{ errors.first('bairro') }}
                  </div>
                </div>
              </div>
              <div class="form-group margin-b30 input-box-control inline input-box-medium" :class="{'has-error': errors.has('cidade')}">
                <div class="label-box"><label>Cidade:*</label></div>
                <div class="input-box">
                  <input type="text" name="cidade" v-model="address.city" v-validate="'required|max:30'" class="form-control small" maxlength="30">
                  <div class="help-block">
                    {{ errors.first('cidade') }}
                  </div>
                </div>
              </div>
              <div class="form-group margin-b30 input-box-control inline input-box-state" :class="{'has-error': errors.has('estado')}">
                <div class="label-box"><label>Estado:*</label></div>
                <div class="input-box">
                  <input type="text" name="estado" v-model="address.state" v-validate="'required|max:2'" class="form-control small" maxlength="2">
                  <div class="help-block">
                    {{ errors.first('estado') }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- </div> -->
          <!-- </div> -->
        </div>
      </div>
    <!-- </div> -->
  </form>
</template>
<style scoped lang="scss">
  /*.inline .help-block,
  .input-box-cep .help-block {
    position: absolute;
    margin-left: 104px;
  }*/
  .form-box {
    min-height: 320px;
  }
  .label-box.number-box {
    width: 135px;
  }
  .cep-validate {
    padding-left: 10px;
  }
  .input-box-adjunct .input-box {
    width: 175px;
  }
  #form-address {
    margin-bottom: 0px;
  }
  @media (max-width: 991px) {
    .form-group {
      width: 100% !important;
    }
    .label-box,
    .label-box.number-box {
      text-align: left;
      width: 100%;
    }
    .input-box {
      width: 100% !important;
    }
  }
</style>
<script>
import messageDialog from '../../components/message-dialog.vue'
import account from '../../services/account'

export default{
  props: ['type', 'address'],
  data() {
    return {
        loadingAddress: undefined,
        errorCep: undefined
    }
  },
  created: function(){
    this.address.type = this.type;

    if(this.address.zipCode && (this.address.address == undefined || this.address.address.length == 0))
      this.queryAddress();


    this.$watch('address', () => {
      let vm = this;
      setTimeout(function(){
        vm.$validator.validateAll()
        .then(() => {
          vm.address.validForm = true;
        })
        .catch(err => {
          vm.address.validForm = false;
        })
      }, 300);
    }, { deep: true });

  },
  methods:{
    queryAddress() {
      this.errorCep = undefined;
      this.loadingAddress = account.queryAddress(this.address.zipCode)
        .then((resp) => {
          let addressId = this.address.addressId;
          let a = resp;
          
          // this.address = resp;
          this.address.address = a.address;
          this.address.city = a.city;
          this.address.neighborhood = a.neighborhood;
          this.address.state = a.state;
          this.address.zipCode = a.zipCode;
          


        if(this.address.address.length == 0 && this.address.neighborhood.length == 0)
            this.address.number='';
        })
        .catch((err) => {

          this.errorCep = err.data.status.message;
          this.$validator.validateAll();
        });
    },
    queryAddressTyping(){
      if(this.address.zipCode.length < 8)
        return;

      this.queryAddress();
    }

  }
}
</script>



// WEBPACK FOOTER //
// address.vue?8bcbbf48